import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function RequestErrorMessage({
  isFallback,
  validationErrors,
  withSeparateNestedErrors = false,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const getErrorDetail = (error) =>
    withSeparateNestedErrors && error.error.source.nestedResource ?
      error.error.nestedErrorDetail
    : error.error.detail;

  return isFallback ?
      <p>{i18nTShared('errors.generic')}</p>
    : <>
        <p className='tw-mb-2'>{i18nTShared('errors.fixFollowing')}</p>
        <ul className='tw-mb-0'>
          {Object.keys(validationErrors).map((key, index) => (
            <li key={index}>{getErrorDetail(validationErrors[key])}</li>
          ))}
        </ul>
      </>;
}

RequestErrorMessage.propTypes = {
  isFallback: PropTypes.bool.isRequired,
  validationErrors: PropTypes.object.isRequired,
  withSeparateNestedErrors: PropTypes.bool,
};
